import { render } from "./Makeup.vue?vue&type=template&id=3e49b83c"
import script from "./Makeup.vue?vue&type=script&lang=js"
export * from "./Makeup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__